module.exports = __webpack_public_path__ + "static/media/cbrtCapital.c87e0c35.png";